export default "__VITE_ASSET__BZwN5gug__"